import React from "react";

const Calendar = (props) => {
  return (
    <div style={{ display: "flex", alignItems: "left" }}>
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
        <div style={{ display: "flex", flexDirection: "column", width: "250px" }}>
          {props.title}
          <input
            type="date"
            className="date-input form-control"
            onChange={(e) => {
              props.onCalendarClick(e.target.value);
            }}
            value={props.dateToShow || ""}
            style={{
              width: "100%",
              borderRadius: "5px",
              paddingLeft: "10px",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Calendar;
